import React from "react";
import {
	Container,
	Typography,
	Button,
	Grid,
	Box,
} from "@material-ui/core";
import ErrorIcon from "@mui/icons-material/Error";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: "#F4F6F8",
		minHeight: "100vh",
		paddingTop: 48,
		paddingBottom: 80,
	},
	header: {
		textAlign: "center",
		marginBottom: 48,
	},
	headerTitle: {
		fontSize: 56,
		fontWeight: 700,
		color: theme.palette.error.main,
		letterSpacing: "-0.5px",
	},
	mainContainer: {
		display: "flex",
		gap: 32,
		alignItems: "flex-start",
		justifyContent: "center",
		marginBottom: 48,
		[theme.breakpoints.down("md")]: {
			flexDirection: "column",
			gap: 24,
			alignItems: "center",
		},
	},
	errorCard: {
		background: "#FFFFFF",
		borderRadius: 16,
		padding: 48,
		width: 550,
		textAlign: "center",
		boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		[theme.breakpoints.down("md")]: {
			width: "100%",
			padding: 32,
		},
	},
	errorIcon: {
		fontSize: "96px !important",
		color: theme.palette.error.main,
		marginBottom: 24,
	},
	errorTitle: {
		fontSize: 28,
		fontWeight: 700,
		color: "#2D2D2D",
		marginBottom: 24,
		lineHeight: 1.3,
	},
	errorDescription: {
		fontSize: 16,
		color: "#6B7280",
		marginBottom: 32,
		lineHeight: 1.6,
	},
	supportCard: {
		background: "#FFFFFF",
		borderRadius: 16,
		padding: 32,
		width: 420,
		boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)",
		[theme.breakpoints.down("md")]: {
			width: "100%",
		},
	},
	supportTitle: {
		fontSize: 18,
		fontWeight: 700,
		color: "#2D2D2D",
		marginBottom: 16,
	},
	supportText: {
		fontSize: 14,
		color: "#6B7280",
		lineHeight: 1.6,
		marginBottom: 16,
	},
	supportLink: {
		color: theme.palette.primary.main,
		fontWeight: 600,
		textDecoration: "none",
		"&:hover": {
			textDecoration: "underline",
		},
	},
	footerButton: {
		height: 52,
		width: 300,
		borderRadius: 8,
		fontWeight: 700,
		fontSize: 14,
		textTransform: "uppercase",
		letterSpacing: 0.5,
		backgroundColor: theme.palette.primary.main,
		color: "#FFFFFF",
		"&:hover": {
			backgroundColor: theme.palette.primary.dark || theme.palette.primary.main,
			boxShadow: `0 8px 24px ${theme.palette.primary.main}33`,
		},
		[theme.breakpoints.down("md")]: {
			width: "100%",
			maxWidth: 300,
		},
	},
	footerContainer: {
		display: "flex",
		justifyContent: "center",
		marginTop: 48,
		gap: 16,
		flexWrap: "wrap",
		[theme.breakpoints.down("md")]: {
			flexDirection: "column",
			alignItems: "center",
		},
	},
}));

const EntertainmentBookingError = () => {
	const classes = useStyles();
	const history = useHistory();

	const errorMessage = sessionStorage.getItem("@EntertainmentBookingError") || null;

	return (
		<div className={classes.root}>
			<Container maxWidth="lg">
				{/* Header */}
				<Box className={classes.header}>
					<Typography className={classes.headerTitle}>
						Ops! Algo deu errado
					</Typography>
				</Box>

				{/* Main Content */}
				<Box className={classes.mainContainer}>
					{/* Left Column - Error Card */}
					<div className={classes.errorCard}>
						<ErrorIcon className={classes.errorIcon} />
						<Typography className={classes.errorTitle}>
							Erro ao processar a reserva
						</Typography>
						<Typography className={classes.errorDescription}>
							{errorMessage || "Não foi possível completar sua reserva neste momento. Por favor, tente novamente ou entre em contato com nosso suporte."}
						</Typography>
					</div>

					{/* Right Column - Support Card */}
					<div className={classes.supportCard}>
						<Typography className={classes.supportTitle}>
							Precisa de ajuda?
						</Typography>

						<Typography className={classes.supportText}>
							Se o problema persistir, nossa equipe de suporte está pronta para ajudá-lo. Entre em contato conosco:
						</Typography>

						<Typography className={classes.supportText}>
							<strong>Email:</strong><br />
							<a href="mailto:suporte@destinoferias.com.br" className={classes.supportLink}>
								suporte@destinoferias.com.br
							</a>
						</Typography>

						<Typography className={classes.supportText}>
							<strong>Telefone:</strong><br />
							<a href="tel:+551140001234" className={classes.supportLink}>
								+55 (11) 4000-1234
							</a>
						</Typography>

						<Typography className={classes.supportText} style={{ fontSize: 12, color: "#9CA3AF", marginTop: 24 }}>
							Referência: {new Date().toISOString()}
						</Typography>
					</div>
				</Box>

				{/* Footer Buttons */}
				<Box className={classes.footerContainer}>
					<Button
						className={classes.footerButton}
						onClick={() => history.push("/busca")}
					>
						Tentar Novamente
					</Button>
					<Button
						className={classes.footerButton}
						onClick={() => history.push("/minhas-viagens")}
					>
						Minhas Viagens
					</Button>
				</Box>
			</Container>
		</div>
	);
};

export default EntertainmentBookingError;
